import { navigate } from 'gatsby'
import {
  Button,
  type ButtonProps,
} from '@livechat/design-system-react-components'

interface Props extends ButtonProps {
  cartId: string
  disabled: boolean
}

const GoToCheckoutButton = ({ disabled, cartId, ...buttonProps }: Props) => {
  const navigateToCart = () => {
    navigate(`/checkout/cart/${cartId}`)
  }

  return (
    <Button
      data-test="go-to-checkout-btn"
      {...buttonProps}
      disabled={disabled}
      onClick={navigateToCart}
    >
      Go to checkout
    </Button>
  )
}

export default GoToCheckoutButton
